var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/document-upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-upload_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19Z",
    fill: "#009FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7997 2.20999C15.3897 1.79999 14.6797 2.07999 14.6797 2.64999V6.13999C14.6797 7.59999 15.9197 8.80999 17.4297 8.80999C18.3797 8.81999 19.6997 8.81999 20.8297 8.81999C21.3997 8.81999 21.6997 8.14999 21.2997 7.74999C19.8597 6.29999 17.2797 3.68999 15.7997 2.20999Z",
    fill: "#009FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5304 12.47L9.53043 10.47C9.52043 10.46 9.51043 10.46 9.51043 10.45C9.45043 10.39 9.37043 10.34 9.29043 10.3C9.28043 10.3 9.28043 10.3 9.27043 10.3C9.19043 10.27 9.11043 10.26 9.03043 10.25C9.00043 10.25 8.98043 10.25 8.95043 10.25C8.89043 10.25 8.82043 10.27 8.76043 10.29C8.73043 10.3 8.71043 10.31 8.69043 10.32C8.61043 10.36 8.53043 10.4 8.47043 10.47L6.47043 12.47C6.18043 12.76 6.18043 13.24 6.47043 13.53C6.76043 13.82 7.24043 13.82 7.53043 13.53L8.25043 12.81V17C8.25043 17.41 8.59043 17.75 9.00043 17.75C9.41043 17.75 9.75043 17.41 9.75043 17V12.81L10.4704 13.53C10.6204 13.68 10.8104 13.75 11.0004 13.75C11.1904 13.75 11.3804 13.68 11.5304 13.53C11.8204 13.24 11.8204 12.76 11.5304 12.47Z",
    fill: "#009FFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document-upload.30462e509a4decf76dd987311bdec4c9.svg";
export { ForwardRef as ReactComponent };